import mongoose from 'mongoose';
import paymentTransactionSchema, {
  IPaymentTransactionDocument,
} from '../schemas/payment-transaction';

export default (mongoose.models.PaymentTransaction ||
  mongoose.model<IPaymentTransactionDocument>(
    'PaymentTransaction',
    paymentTransactionSchema,
  )) as mongoose.Model<IPaymentTransactionDocument>;
